module.exports = __webpack_public_path__ + "static/media/IMG_20191019_220056.852473ab.webp";